function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { width, space } from 'styled-system';
import { buttonStyles } from '../Button';
import { applyVariations, getPaletteColor, deprecatedColorValue } from '../utils';
var variations = {
  fill: css(["&:hover{text-decoration:none;}", ""], buttonStyles),
  link: css(["cursor:pointer;text-decoration:none;color:", ";&:hover{color:", ";text-decoration:underline;}"], getPaletteColor('base'), getPaletteColor('dark')),
  outline: css(["&:hover{text-decoration:none;}", ""], buttonStyles)
};
var Link = styled.a.attrs(function (_ref) {
  var target = _ref.target,
      props = _objectWithoutProperties(_ref, ["target"]);

  return _objectSpread({
    rel: target === '_blank' ? 'noopener' : null,
    target: target
  }, props);
}).withConfig({
  displayName: "Link",
  componentId: "sc-16qjtx7-0"
})(["", " ", " ", ";"], applyVariations('Link', variations), width, space);
Link.displayName = 'Link';
Link.defaultProps = {
  color: 'primary',
  variation: 'link',
  size: 'medium'
};
Link.propTypes = {
  color: deprecatedColorValue(),
  variation: PropTypes.oneOf(Object.keys(variations))
};
export default Link;